import springReportsApi from '../../services/springReportsApi'

export const customersSegmentByGenderReport = data => (
	new Promise((resolve, reject) => {
		springReportsApi()
			.post('/customers/segment_by_gender', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const customersSegmentByAgeRangeReport = data => (
	new Promise((resolve, reject) => {
		springReportsApi()
			.post('/customers/segment_by_age_range', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const customersSegmentByFormatAndGenderReport = data => (
	new Promise((resolve, reject) => {
		springReportsApi()
			.post('/customers/segment_by_format_and_gender', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const customersSegmentByFormatAndAgeRangeReport = data => (
	new Promise((resolve, reject) => {
		springReportsApi()
			.post('/customers/segment_by_format_and_age_range', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)   